module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Solothurn_matt-6a27095f4245c0856f9d4bf6006e2f06.svg";